export function getCategoryItems(_ref) {
  var _ref$categories = _ref.categories,
    categories = _ref$categories === void 0 ? [] : _ref$categories,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  return categories.map(function (_ref2) {
    var name = _ref2.name,
      categoryItems = _ref2.items;
    return {
      name: name,
      items: items.filter(function (_ref3) {
        var itemId = _ref3._id;
        return categoryItems.includes(itemId);
      })
    };
  });
}
export function getCategoryNameFromItems(itemId, category) {
  var categories = category.filter(function (item) {
    return item.items.includes(itemId);
  });
  if (categories && categories.length) {
    return categories[0].name;
  }
  return '';
}